<ion-header>
    <ion-toolbar>
        <ion-title role="heading"></ion-title>
        <ion-buttons slot="end">
            <ion-button
                class="icon-button-accessible-background-contrast"
                [attr.aria-label]="'ARIA_LABEL_CLOSE' | translate"
                (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>

        <ion-row>
            <ion-col *ngFor="let d of weekdaysShort" class="weekday-label">{{ d }}</ion-col>
        </ion-row>

        <div *ngFor="let month of months">
            <div class="month-label">{{ month.text }}</div>

            <ion-row *ngFor="let week of month.weeks">
                <ion-col
                    *ngFor="let day of week.days"
                    class="day"
                    [ngClass]="{
                        'outside-study': !day.isInStudy,
                        'outside-month': day.isOutsideMonth
                    }">
                    {{ day.dayNum }}
                </ion-col>
            </ion-row>
        </div>

    </ion-grid>
</ion-content>